import React from "react";
import { Stack, Text } from "sprint-common-web";
import { BucketFile, BucketObject } from "sprint-common-web/src/components/explorer/BucketObject";

export const renderSelectedFilesTooltipContent = (selectedFiles: BucketFile[]): JSX.Element => {
    return (
        <Stack styles={{ root: { overflow: "auto", maxHeight: 150 } }}>
            {selectedFiles.map((selectedFile: BucketObject) => {
                return (
                    <Text styles={{ root: { padding: 5, paddingRight: 15 } }} key={selectedFile.path}>
                        {selectedFile.name}
                    </Text>
                );
            })}
        </Stack>
    );
};
